import * as React from 'react';
import { connect } from 'react-redux';
import { ErrorStore } from 'Redux/Actions/Models/ErrorActionModel';
import * as ErrorActions from 'Redux/Actions/ErrorActions';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import * as UserModule from 'Modules/UserModule';

type DispatchedP = {
    t?: Function;
    clearErrorStore: () => void;
};

type ConnectedP = {
    errorStore: ErrorStore;
    userStore: UserModule.Types.UserStore;
};

class ErrorHandler extends React.Component<DispatchedP & ConnectedP, {}> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { t, errorStore } = this.props;
        if (
            errorStore.responseError.status === 500 ||
            errorStore.responseError.status === 405 ||
            errorStore.responseError.status === 404 ||
            errorStore.responseError.status === 400 ||
            errorStore.unknownError
        ) {

            let parameters = [];
            try {
                parameters = errorStore.responseError.data?.parameters || null;
            } catch (e) {
                console.log(e);
                parameters = null;
            }


            return (
                <div className="error">
                    <div className="error__inner">
                        {errorStore.responseError.data && errorStore.responseError.data.errorCode && errorStore.responseError.status === 400 ? (
                            <div className="error__message">
                                <p>{errorStore.responseError.data.errorSubcode === 'RIDE_TO_LONG_PERIOD' ? <p>{errorStore.responseError.data.message}</p> : `${t(errorStore.responseError.data.errorCode)}:`}</p>
                                {parameters && parameters.map((param, i) => (
                                    <p key={`${i}${param}`}>{t(param)}</p>
                                ))}
                            </div>
                        ) : (
                            <>
                                <h2 className="font-bold">{t('somethingWentWrong')}</h2>
                                <p className="font-lg">
                                    Skontaktuj się z nami pod adresem
                                    <a href="mailto:pomoc@vehis.pl"
                                        className="font-bold font-blue ml-10">pomoc@vehis.pl</a>
                                </p>
                                {/* <pre>{moment().format('MMMM Do YYYY, HH:mm:ss')}</pre>
                                <pre>{JSON.stringify(errorStore.responseError.data)}</pre>
                                <pre>{JSON.stringify(errorStore.responseError.status)}</pre>
                                <pre>{JSON.stringify(errorStore.responseError.headers)}</pre> */}
                            </>
                        )}
                    </div>
                    <div className="error__exit" onClick={() => this.props.clearErrorStore()} />
                </div>
            );
        } else if (errorStore.news) {
            return <p className={errorStore.news.type === 'ERROR' ? 'info-box info-box--error' : 'info-box'}
                date-e2eid={"createinfoBox"}>{errorStore.news.message}</p>;
        } else {
            return null;
        }
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        errorStore: state.errorStore,
        userStore: state.userStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        clearErrorStore: () => dispatch(ErrorActions.clearErrorStore())
    };
}

export default withTranslation('errors')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(ErrorHandler) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/ErrorHandler/ErrorHandler.tsx